import { Box, Switch, Typography } from "@mui/material";
import { useColorMode } from "../provider/ThemeProviderEx";

export default function AppHeader() {
  const { mode, toggleMode } = useColorMode();

  return (
    <Box
      sx={(theme) => ({
        position: "relative",
        p: 2,
        display: "flex",
        alignItems: "center",
        backgroundColor: theme.palette.background.default,
        color: "text.primary",
      })}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" }, // responsive font size
          position: "absolute",
          left: "50%",
          top: { xs: "100%", sm: "50%" },
          transform: "translate(-50%, -50%)",
          m: 0,
          whiteSpace: "nowrap",
        }}
      >
        Zákaznická&nbsp;Virtuální&nbsp;Kancelář
      </Typography>

      <Box
        sx={{
          ml: "auto",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography component="span">☀️</Typography>
        <Switch checked={mode === "dark"} onChange={toggleMode} />
        <Typography component="span">🌙</Typography>
      </Box>
    </Box>
  );
}
